import { STUDENT_ACTIVITY_COLUMN_HEADERS } from '../constants';
import { ORDER_OPTIONS } from '../../hooks/useSortableTable';

export const normalizeString = (str) =>
  str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const sortStudents = (students, sortBy, sortOrder) =>
  [...students].sort((a, b) => {
    const sortConstant = sortOrder === ORDER_OPTIONS.ASC ? 1 : -1;

    if (
      sortBy === STUDENT_ACTIVITY_COLUMN_HEADERS.STUDENT_NAME ||
      a.launched_at === b.launched_at
    ) {
      const fullNameA = a.last_name.concat(', ').concat(a.first_name);
      const fullNameB = b.last_name.concat(', ').concat(b.first_name);
      const normalizedNameA = normalizeString(fullNameA);
      const normalizedNameB = normalizeString(fullNameB);
      return (
        sortConstant *
        normalizedNameA.localeCompare(normalizedNameB, 'en', {
          sensitivity: 'base',
        })
      );
    }

    if (!a.launched_at) {
      return sortConstant * -1;
    }
    if (!b.launched_at) {
      return sortConstant * 1;
    }

    const launchDateA = new Date(a.launched_at);
    const launchDateB = new Date(b.launched_at);
    return sortConstant * (launchDateA - launchDateB);
  });
